// extracted by mini-css-extract-plugin
module.exports = {"publicEnrollment":"PublicEnrollment_publicEnrollment__22R94","error":"PublicEnrollment_error__3mnPJ"};